/* =========================================================================
 * /docs/appTerms — mobile app terms & conditions.
 *
 * Rewritten as part of the 2026 redesign — uses the shared LegalDoc layout
 * (DefaultNavbar + SiteFooter + brand typography) instead of the old
 * Creative Tim card pattern.
 * ========================================================================= */

import { LegalDoc } from "pages/Docs/components/LegalDoc";

const SECTIONS = [
  {
    title: "App usage",
    body: (
      <p>
        The App is provided for informational and analytical purposes only. You may use the App
        solely for its intended purpose.
      </p>
    ),
  },
  {
    title: "Data collection and usage",
    body: (
      <p>
        The App may collect and transmit certain non-personal data, such as sensor data (e.g.,
        location, gyroscope, microphone amplitude, light, barometer) from your device, for the
        purpose of providing our services. By using the App, you consent to the collection and
        transmission of such data. For the full sensor reference, see{" "}
        <a href="/docs/what">What data we collect</a>.
      </p>
    ),
  },
  {
    title: "User responsibilities",
    body: (
      <p>
        You are responsible for the use of the App and any data generated or transmitted by the App.
      </p>
    ),
  },
  {
    title: "Intellectual property",
    body: (
      <p>
        All content and materials provided through the App are the property of{" "}
        <strong>Halyard LLC</strong> or its licensors and are protected by intellectual property
        laws.
      </p>
    ),
  },
  {
    title: "Limitation of liability",
    body: (
      <p>
        In no event shall <strong>Halyard LLC</strong> be liable for any direct, indirect,
        incidental, special, or consequential damages arising out of or in any way connected with
        the use of the App or any data collected or transmitted by the App.
      </p>
    ),
  },
  {
    title: "Modification of terms",
    body: (
      <p>
        <strong>Halyard LLC</strong> reserves the right to modify these terms and conditions at any
        time. Any changes will be effective immediately upon posting within the App. Your continued
        use of the App after the posting of changes constitutes your acceptance of such changes.
      </p>
    ),
  },
  {
    title: "Governing law",
    body: (
      <p>
        These terms and conditions shall be governed by and construed in accordance with the laws of
        the United States, without regard to its conflict of law provisions.
      </p>
    ),
  },
  {
    title: "Contact",
    body: (
      <p>
        If you have any questions or concerns about these terms and conditions, please contact us at{" "}
        <a href="mailto:contact@bripplex.com">contact@bripplex.com</a>.
      </p>
    ),
  },
];

export const MobileTerms = () => (
  <LegalDoc
    eyebrow="Legal"
    title="Mobile app terms & conditions"
    lastUpdated="July 2024"
    lead={
      <>
        By downloading, installing, or using the Bripplex mobile application (the &ldquo;App&rdquo;)
        you agree to comply with and be bound by the following terms. Please review them carefully —
        if you do not agree, do not install or use the App.
      </>
    }
    sections={SECTIONS}
    footnote={
      <>
        By using the App, you acknowledge that you have read, understood, and agree to be bound by
        these terms and conditions.
      </>
    }
  />
);
